import { madrFilePathFilter } from '@backstage-community/plugin-adr-common';

export const simCorpFilePathFilter = (path: string) => {
  if (path === 'cs-adr-00000-template.md') {
    return false;
  }

  return /^cs-adr-\d{5}-.+\.md$/.test(path) || madrFilePathFilter(path);
}
